<app-language></app-language>
<div id="loader_form">
    <div data-loader="circle-side-2"></div>
</div><!-- /loader_form -->

<router-outlet></router-outlet>